module.exports = __webpack_public_path__ + "static/media/15.77c12d54.jpg";